import { TG_BASE_URL } from '../data/constants';

export const getTgLink = (text: string): string => 
  `${TG_BASE_URL}?text=${encodeURIComponent(text)}`;